import { RankedGamesDescriptionDialogContainer } from './RankedGamesDescriptionDialogContainer.tsx';
import { mountDialogUIReactComponent } from '../../ui_platform/mountDialogUIReactComponent.tsx';
export const showRankedGamesDescriptionDialog = mountDialogUIReactComponent(RankedGamesDescriptionDialogContainer);
